import ParseConfig from './utils/ParseConfig';

// 用户初始化时  生成一个单例
class TraceInit {
  config; // 存储埋点配置信息的config, 外面传进来的或者是从指定位置读取的
  parseConfig; // 解析config的方法，使用我们提供的或者是用户自己提供的
  isSpm = false;

  constructor(config = {}, parse) {
    if (config) {
      this.config = config;
    }
    if (!this.config || Object.keys(this.config).length === 0) {
      throw '请传入埋点配置信息config';
    }

    this.parseConfig = parse || ParseConfig;
    this.isSpm = parse ? false : true;
  }

  // 单例config是必传项
  static getInstance(config, parseConfig) {
    if (!this.instance) {
      this.instance = new TraceInit(config, parseConfig);
    }
    return this.instance;
  }
}

export default TraceInit;
